import React from 'react'
import clsx from 'clsx'
import { Controller } from 'react-hook-form'
import { RegisterOptions } from 'react-hook-form/dist/types/validator'
import { FieldErrors } from 'react-hook-form/dist/types/errors'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import { OptionType } from '../models'

interface IUseStyles {
  direction?: 'row' | 'column'
}

interface IReactHookRadio extends IUseStyles {
  name: string
  label?: string
  control: any
  rules: RegisterOptions
  errors: FieldErrors
  options: OptionType[]
}

const useStyles = makeStyles(theme =>
  createStyles({
    wrap: {
      position: 'relative',
      padding: '14px 0 24px',

      '& > label': {
        display: 'inline-block',
        marginBottom: 8,
      },
    },
    root: {
      flexDirection: ({ direction }: IUseStyles) => direction,
    },
    icon: {
      borderRadius: '50%',
      width: 24,
      height: 24,
      border: `1px solid ${theme.colors.grey}`,
    },
    checkedIcon: {
      border: `6px solid ${theme.colors.black}`,
    },
    error: {
      fontFamily: theme.fonts.inter,
      fontWeight: 'normal',
      fontSize: 12,
      lineHeight: 1.5,
      color: theme.colors.red,
      position: 'absolute',
      bottom: 0,
      left: 24,
    },
  })
)

const ReactHookRadio = (props: IReactHookRadio) => {
  const { name, control, label, rules, errors, options, direction = 'column' } = props
  const classes = useStyles({ direction })

  return (
    <Controller
      render={({ field }) => (
        <div className={classes.wrap}>
          {label && <label>{label}</label>}
          <RadioGroup {...field} classes={{ root: classes.root }}>
            {options.map(({ value, label }) => (
              <FormControlLabel
                key={label}
                value={value}
                control={
                  <Radio
                    disableRipple
                    color="default"
                    checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                    icon={<span className={classes.icon} />}
                    {...props}
                  />
                }
                label={label}
              />
            ))}
          </RadioGroup>
          {errors?.[name]?.message && (
            <FormHelperText className={classes.error}>{errors?.[name]?.message}</FormHelperText>
          )}
        </div>
      )}
      name={name}
      control={control}
      rules={rules}
    />
  )
}

export default ReactHookRadio
